const getters = { 
    loginType: state => state.user.loginType,
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    isLoggedIn: state => state.user.isLoggedIn,
    isAuthenticated: state => !!state.accessToken,
    user: state => state.user,
    isLoading: state => state.isLoading,
    accessToken: state => state.accessToken
}

export default getters
